module.exports = __webpack_public_path__ + "img/Rlogo2.ab5e11c2.svg";